<template>
  <Portal to="secondary-info">
    <div class="bg-white px-3 md:px-6">
      <div
        class="hidden md:flex items-center justify-between pt-5 pb-8 border-0 border-solid border-t border-gray-300 max-w-1140 w-full mx-auto"
      >
        <div class="flex items-stretch justify-start flex-row gap-6">
          <AthleteStat
            :value="classYear"
            class="text-nowrap flex flex-1 flex-col justify-between items-stretch"
            label="GRAD YR"
          />
          <AthleteStat class="flex flex-col justify-between items-stretch" :value="homeTownString" label="HOMETOWN" />
          <AthleteStat
            :value="athleteAffiliation.value"
            :label="athleteAffiliationLabel"
          />
          <AthleteStat
            v-if="user.height"
            class="hidden lg:flex flex-1 flex-col justify-between items-stretch"
            :value="user.height | formatHeight"
            label="HT"
          />
          <AthleteStat
            v-if="user.weight"
            class="hidden lg:flex flex-1 flex-col justify-between items-stretch"
            :value="user.weight + 'lbs'"
            label="WT"
          />
          <AthleteStat
            v-if="gpa"
            class="hidden lg:flex flex-1 flex-col justify-between items-stretch"
            :value="gpa"
            :label="gpaLabel"
          />
        </div>
        <div class="mt-3 ml-6 flex gap-1 items-end">
          <InterestedPill v-if="athleteIsInterestedInProgram" position="top-end" />
          <SportPill v-if="showSportPill" :sport="sportName" :gender="user.gender" />
          <CommittedPill position="top-end" />
        </div>
      </div>
      <div
        v-if="homeTownString || athleteAffiliation"
        class="flex md:hidden border-0 border-solid border-t border-gray-300"
      >
        <div class="flex items-stretch justify-around flex-row w-full pt-3 pb-3">
          <AthleteStat
            v-if="homeTownString"
            class="flex-1 text-center flex flex-col justify-between items-stretch"
            label="HOMETOWN"
            :value="homeTownString"
          />
          <AthleteStat
            v-if="athleteAffiliation"
            class="flex-1 text-center flex flex-col justify-between items-stretch"
            :value="athleteAffiliation.value"
            :label="athleteAffiliation.type"
          />
        </div>
      </div>
    </div>
  </Portal>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import CommittedPill from "./CommittedPill.vue";
import SportPill from "./SportPill.vue";
import { AthleteAffiliation } from './Objects/AthleteAffiliation';
import AthleteStat from './AthleteStat.vue';
import InterestedPill from "./InterestedPill.vue";

export default {
  name: "AthleteSecondaryInfo",
  components: {
    InterestedPill,
    CommittedPill,
    AthleteStat,
    SportPill,
  },
  computed: {
    ...mapState("athleteProfile", ["user"]),
    ...mapGetters("athleteProfile", [
      "allClubAffiliations",
      "allHighSchoolAffiliations",
      "homeTownString",
      "teamAffiliations",
      "sportName",
      "isUserWithoutAccess",
      "athleteIsInterestedInProgram",
    ]),
    athleteAffiliation() {
      const athleteAffiliation = new AthleteAffiliation(this.teamAffiliations, this.allClubAffiliations, this.allHighSchoolAffiliations);
      return athleteAffiliation.getAffiliation();
    },
    athleteAffiliationLabel() {
      return this.athleteAffiliation.type ? this.athleteAffiliation.type : 'TEAM';
    },
    classYear() {
      return this.user.classYear ? `${this.user.classYear} ${this.user.isTransfer ? 'Transfer' : ''}` : false;
    },
    gpa() {
      return this.user.gpa.value ? `${this.user.gpa.value}/${this.user.gpa.scale}` : false;
    },
    gpaLabel() {
      return this.user.gpa.isWeighted ? 'GPA (weighted)' : 'GPA';
    },
    showSportPill() {
      return this.isUserWithoutAccess && this.sportName;
    },
  },
}
</script>
<style scoped>
.text-nowrap {
  white-space: nowrap;
}
</style>
